<template>
  <div class="box">
    <div class="card" v-if="clientWidth > 768">
      <img src="https://staticdn.ht-s.cn/se/ciif/2023/index/1_card.png" alt="">
<!-- \ <div class="card_box" v-for="item in introllist" :key="item.title">
        <img class="card_img" :src="item.img" alt="" />
        <p>{{ item.title }}</p>
      </div> -->
    </div>
    <div class="card_m" v-else>
      <img src="https://staticdn.ht-s.cn/se/ciif/2023/index/1_card_m.png" alt="">
    </div>
    <swiper :options="swiperOption_m" v-if="false" ref="mySwiper" :auto-play="true" class="card">
      <div
        v-if="clientWidth < 768"
        class="swiper-button-prev s-prev"
        slot="button-prev"
      ></div>
      <div
        v-if="clientWidth < 768"
        class="swiper-button-next s-next"
        slot="button-next"
      ></div>
      <swiper-slide v-for="item in introllist" :key="item.title" class="card_box">
        <img class="card_img" :src="item.img" alt="" />
        <p>{{ item.title }}</p>
        <!-- <div class="card_children">
          <div class="children_box" v-for="val in item.children" :key="val">
            <img
              class="icon_arrow"
              src="https://staticdn.ht-s.cn/se/ciif/2023/index/icon_arrow.png"
              alt=""
            />
            <span>{{ val }}</span>
          </div>
        </div> -->
      </swiper-slide>
      <!-- 指示点 -->
      <!-- <div class="swiper-pagination fx2" slot="pagination"></div> -->
    </swiper>
    <div v-if="false" class="intronumber">
      <!-- <img src="" alt=""> -->
      <div class="left"></div>
      <span>{{currentIndex}}/{{introllist.length}}</span>
      <div class="right"></div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import 'swiper/swiper-bundle.min.css';
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

export default {
  props: {
    introllist: {
      type: Array,
      value: []
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const that = this
    return {
      currentIndex: 1,
      swiperOption_m: {
        direction: "horizontal",
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // loop: true,
        slidesPerView: 1.52,
        centeredSlides: true,
        spaceBetween: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on:{
          slideChange:(swiper) => { that.currentIndex = swiper.realIndex + 1 }
        }
      },
    };
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>